import React from 'react';
import { MOBILE_BREAKPOINT, TRANSLATIONS } from '../../constants';
import { useHook } from '../../hooks';
import { useResized, useTranslate } from '../../hooks/common';
import { SupportEntryCategory } from '../../models';
import Accordion from '../common/Accordion';
import Flex, { FlexDirection, FlexJustification, FlexWrap } from '../common/Flex';
import SupportEntrySubcategoryCard from './SupportEntrySubcategoryCard';

export interface SupportEntryAccordionProps {
    supportEntry: SupportEntryCategory;
}

const SupportEntryAccordion = ({ supportEntry }: SupportEntryAccordionProps) => {
    const mobileView = useResized(x => x <= MOBILE_BREAKPOINT);
    const { open, handleAccordionClick } = useHook(x => x.supportEntry)();
    const translate = useTranslate();
    const closedLabel = supportEntry.supportEntrySubCategories?.length <= 1
        ? `${supportEntry.supportEntrySubCategories?.length} ${translate(TRANSLATIONS.main.entry)}`
        : `${supportEntry.supportEntrySubCategories?.length} ${translate(TRANSLATIONS.main.entries)}`;

    const getSupportEntryItem = (supportEntryCategory: SupportEntryCategory) => supportEntryCategory.supportEntrySubCategories.map(x =>
        <SupportEntrySubcategoryCard supportEntrySubcategory={x} key={x.id}></SupportEntrySubcategoryCard>);

    return <Accordion label={supportEntry.name} closedLabel={closedLabel} open={open} onClick={handleAccordionClick}>
        {!mobileView
            ? <Flex direction={FlexDirection.Row} justification={FlexJustification.SpaceEvenly} wrap={FlexWrap.Wrap}>{getSupportEntryItem(supportEntry)}</Flex>
            : getSupportEntryItem(supportEntry)
        }
    </Accordion>;
};

export default SupportEntryAccordion;
